var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-t-default"},[_c('site-header'),_vm._v(" "),(_vm.isCompany)?_c('my-pages-company',{attrs:{"isCompany":_vm.isCompany}}):(_vm.isCustomer)?_c('my-pages-customer',{attrs:{"isCustomer":_vm.isCustomer}}):_vm._e(),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3a287da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyPages.vue
// module id = 1333
// module chunks = 0